export const OPD_ORDERS_CONSTANTS = {
  PATIENT_IDENTIFIER: 'patientIdentifier',
  ORIGIN_OPD: 'OPD',
  MODE_RADIOLOGY: 'radiology',
  MODE_TEST: 'test',
  MODE_PACKAGE: 'package',
  STATUS_ORDER_MODIFIED: 'ORDER_MODIFIED',
  STATUS_ORDERED: 'ORDERED',
  TYPE_VISIT: 'visit' as const,
  TYPE_PATIENT: 'patient' as const,
  LABEL_RADIOLOGY: 'Radiology',
  LABEL_PACKAGE: 'Package',
  LABEL_TEST: 'Test',
  PLACEHOLDER_RADIOLOGY_TEST: 'Select Radiology Test',
  CLASSNAME_REACT_SELECT: 'react-select',
  CLASSNAME_POINTER_EVENTS_NONE: 'pointer-events-none',
  CLASSNAME_POINTER_EVENTS_AUTO: 'pointer-events-auto',
  BUTTON_TEXT_SAVING: 'Saving...',
  BUTTON_TEXT_SUBMIT_ORDER: 'Submit',
  IDENTIFIER_SPLIT: '/',
  DATE_FORMAT_SLICE: 10,
  TITLE_PREFIX_ORDER: 'Order ',
  TITLE_SEPARATOR: '-',
  CURRENCY_SYMBOL: '₹',
  DECIMAL_PLACES: 2,
  DEFAULT_PRICE: '0.00',
  QUANTITY_DEFAULT: 1,
  FINISHED_STATUS: 'finished',
  PACKAGE_ID_ZERO: 0,
  ACTIVE_INDEX_NEW_ORDER: -1,
  MAX_HEIGHT_OFFSET: 90,
  DOCTOR_PREFIX: 'Dr. ',
  QUALIFICATION_PREFIX: ' (',
  QUALIFICATION_SUFFIX: ')',
  SPECIALTY_PREFIX: ' [',
  SPECIALTY_SUFFIX: ']',
  WINDOW_RESIZE_EVENT: 'resize',
  INTENT_GET_RADIOLOGY_TESTS: 'getRadiologyTestsAPI',
  INTENT_GET_ALL_PANELS: 'getAllPanelsApi',
  INTENT_GET_LAB_ORDERS_BY_PATIENT: 'getLabOrdersByPatientIdForOpd',
  INTENT_GET_LAB_ORDERS: 'getLabOrdersApi',
  INTENT_GET_VISIT: 'getVisitApi',
  INTENT_CREATE_ORDER_EVENT: 'createOrderEvent',
  INTENT_GENERATE_GLOBAL_ID: 'generateGlobalId',
  TOAST_TIMEOUT: 1500,
  ODOO_API_STATUS_ERROR: 'error',
  EVENT_TYPE_ORDERED: 'ORDERED',
  EVENT_TYPE_ORDER_MODIFIED: 'ORDER_MODIFIED',
}
